export default {
    sendmail: { method: 'post', url: 'sendmail' }
}
